import { createEvent, createStore } from "effector";

export type TitleProps = {
  title: string;
  href?: string;
  disabled?: boolean;
};

export const setTitle = createEvent<TitleProps[]>();
export const resetTitle = createEvent();

export const $Title = createStore<TitleProps[]>([
  { title: "Главная", href: "/", disabled: false },
])
  .on(setTitle, (state, newData) => newData)
  .reset(resetTitle);
